import { ck, cr } from "fire-wind-water";
import md5 from "js-md5";
import authService from "@/services/authService";
import { common } from "@/model/common";

class RegisterModel {
  loadForm(self) {
    authService
      .getForm({
        schemaId: self.memberFormId,
        formId: self.memberFormId,
        memberFormId: self.memberFormId,
        isNotAdd: 1,
      })
      .then((data) => {
        self.formInfo = data.content;
        common.handPage(self.formInfo);
        window.$sk.template.update({
          type: "link",
          data: {
            identity: 1,
            weChatId: self.formInfo.authWeChatId || 0,
            skObjectType: "member",
            skObjectId: self.memberFormId,
            meetingInstanceId: "",
            meetingType: "",
            skIsNotLink: "",
            memberFormId: "",
          },
        });
        if (self.formInfo.authWeChatId) {
          self.weChatId = self.formInfo.authWeChatId;
        }
        this.getParamTree(self);
        window.$sk.loading.hide();
        if (self.afterLoadForm) self.afterLoadForm();
      });
  }

  getParamTree(self) {
    Promise.all(
      self.formInfo.items.map((item, index) => {
        item.required = parseInt(item.required);
        if (item.listOptionType == "DICT") {
          return authService
            .getParamTree({
              tenantId: common.tenantId,
              dicId: item.listDictId,
              format: "object",
            })
            .then((res) => {
              // item.dictInfo = res.content[item.listDictId];
              item.dictInfo = Object.values(res.content)[0];
              self.$set(self.formList, index, item);
            });
        } else {
          self.$set(self.formList, index, item);
        }
      })
    ).then(() => {
      self.isLoad = true;
      self.$nextTick(() => {
        cr.each(self.formList, (m) => {
          if (m.isLogin == 1 && m.result) {
            m.result.setAsyncError({
              key: "norepeat",
              message: `您输入的${m.displayName}已注册，请登录`,
              validator: () => {
                return new Promise((resolve) => {
                  authService
                    .checkUnique({
                      memberSchemaId: self.formInfo.schemaId,
                      unique:
                        m.isCallingCodeOpen == 1
                          ? m.value.code + m.result.value
                          : m.result.value,
                      fieldName: m.result.fieldName,
                    })
                    .subscribe((result) => {
                      console.log("result===", result);
                      resolve(result.content.result);
                    });
                });
              },
            });
          }
        });
      });
    });
  }

  register(self) {
    let answers = [];
    let needToken = false;
    self.isSubmitting = true;
    let submitData = {
      tenantId: self.formInfo.tenantId,
      schemaId: self.formInfo.schemaId,
      memberFormId: self.memberFormId,
      url: window.location.href,
      referenceUrl: self.inWeChat
        ? "微信"
        : document.referrer || window.location.href,
      token: self.token || "",
      verify: self.verify || "",
      sourceKey: common.sourceKey,
      globalUserId: common.globalUserId,
    };
    if (self.wx && self.wx.weChatId && self.wx.openId) {
      submitData.isBind = true;
      submitData.weChatId = self.wx.weChatId;
      submitData.openId = self.wx.openId;
    } else {
      if (self.inWeChat && (self.weChatId || self.backUrl)) {
        let weChatId = self.weChatId;
        if (!weChatId) {
          let url = decodeURIComponent(self.backUrl);
          let re = new RegExp("(^|&)" + "weChatId" + "=([^&]*)(&|$)", "i");
          let Parameter = url.match(re);
          if (Parameter !== null) {
            weChatId = Parameter[2];
          }
        }
        let wechatInfo = common.getVerifyInfo(weChatId);
        if (wechatInfo) {
          if (wechatInfo.original) {
            submitData.isBind = true;
            submitData.weChatId = weChatId;
            submitData.openId =
              wechatInfo.original.openid || wechatInfo.original.openId;
            submitData.verify = common.getVerify(weChatId);
          }
        }
      }
    }
    cr.each(self.formList, (item) => {
      let answer = {
        fieldName: item.fieldName,
        value: item.value.value,
      };
      if (item.fieldName === "password") {
        answer.value = md5(answer.value).toUpperCase();
      }
      if (item.fieldName === "enterprise") {
        answer.otherValue = item.value.otherValue;
        answer.thirdValue = item.value.thirdValue;
      }
      answers.push(answer);
      if (item.fieldName == "mobile" && item.isSendSms == "1") {
        needToken = true;
        self.phone = item.value.value;
        submitData["verificationCode"] = item.value.checkCode;
      }
    });
    submitData["formData"] = answers;
    return new Promise((resolve, reject) => {
      if (needToken) {
        let params = {
          unique: self.phone,
          checkCode: submitData["verificationCode"],
          schemaId: self.formInfo.schemaId,
          formId: self.memberFormId,
          action: "register",
          globalUserId: common.globalUserId,
        };
        authService.getToken(params).then((data) => {
          if (data.result != 0) {
            self.isSubmitting = false;
            return window.$sk.tips.show(data["desc"]);
          }
          submitData.token = submitData.token
            ? [submitData.token, data.content.token]
            : data.content.token;
          this.registered(self, submitData, resolve, reject);
        });
      } else {
        this.registered(self, submitData, resolve, reject);
      }
    });
  }

  beforeRegisterHandler(self) {
    let inValid = true;
    self.formList = self.formList.map((item, index) => {
      item.checkFlag = !item.checkFlag;
      return self.$set(self.formList, index, item);
    });
    self.$nextTick(() => {
      self.formList.map((item) => {
        if (item.value.VerifyFail) {
          return (inValid = false);
        }
      });
      if (!inValid) {
        return this.validationErrorHandler(self);
      }
      if (self.update) {
        self.update();
      } else {
        this.register(self);
      }
    });
  }

  validationErrorHandler(self) {
    //判断并找到第1个错误字段，并定位滚动到它的位置
    let anchor = self.$el.querySelector(".err");
    if (anchor) {
      document.body.scrollTop = anchor.offsetTop - 20;
      document.documentElement.scrollTop = anchor.offsetTop - 20;
    }
  }

  registered(self, submitData, resolve, reject) {
    authService.register(submitData).then(
      (data) => {
        if (data.result != 0) {
          self.isSubmitting = false;
          return window.$sk.tips.show(data["desc"]);
        }
        common.setSession(
          {
            session: data.content.sess,
            memberId: data.content.memberId,
          },
          7
        );
        this.afterRegisterHandler(self, data);
        resolve(data);
      },
      (data) => {
        this.afterRegisterHandler(self, data);
        reject(data);
      }
    );
  }

  afterRegisterHandler(self, data) {
    self.isSubmitting = false;
    if (data.result == "0") {
      if (self.afterRegisterHandler) {
        self.afterRegisterHandler(data);
      }
      let settingBackUrl;
      if (!self.backUrl) {
        let backUrlSetting = self.extras.backlink.href;
        settingBackUrl = RegExp("^https?:\\/\\/.+").test(backUrlSetting)
          ? backUrlSetting
          : "";
      }
      if (self.backUrl)
        self.backUrl = "模板配置的backUrl" + window.location.search; //todo
      if (self.backUrl || settingBackUrl) {
        if (self.backUrl) {
          common.handBackUrl(common.backUrl);
        } else {
          window.$sk.goto(settingBackUrl);
        }
      } else {
        common.routerPush(self, "loginSuccess");
      }
    } else {
      window.$sk.tips.show(data.desc);
    }
  }

  record(self) {
    authService
      .record({
        session: "",
        moduleId: "",
        memberId: "",
        cookieId: common.globalUserId,
        url: window.location.href,
        tenantId: self.formInfo.tenantId,
        openId: common.getOpenId(self.weChatId)
          ? common.getOpenId(self.weChatId)
          : "", //联系人openId
        weChatId: self.weChatId, //微信ID
        objId: self.memberFormId, //互动ID 例如表单ID 会议ID
        objTitle: self.formInfo.title, //互动名称   例如2017年的第一场会
        objInstanceId: "0",
        actionKey: "registerForm_browse", //互动行为key
        markCode: common.markCode || "",
        marketingSess: ck.cookie("marketingSess") || "",
      })
      .then(() => {});
  }
}

export const registerModel = new RegisterModel();
